import { memo } from 'react';
import { PublicationDetailProps } from '../../interfaces/components';
import { usePublicationDetail } from '../PublicationDetail/hooks/usePublicationDetail';
import { usePublicationLogic } from '../PublicationDetail/hooks/usePublicationLogic';
import { Chip } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import ServiceBoxs from '../ServiceBoxs';

// Componentes móviles refactorizados
import PublicationMobileHeader from './components/PublicationMobileHeader/PublicationMobileHeader';
import PublicationMobileContent from './components/PublicationMobileContent/PublicationMobileContent';
import PublicationMobileVersionSelector from './components/PublicationMobileVersionSelector/PublicationMobileVersionSelector';
import PublicationMobileDealershipSelector from './components/PublicationMobileDealershipSelector/PublicationMobileDealershipSelector';
import PublicationMobileCharacteristics from './components/PublicationMobileCharacteristics/PublicationMobileCharacteristics';
import PublicationMobileActions from './components/PublicationMobileActions/PublicationMobileActions';
import PublicationMobilePriceIndicator from './components/PublicationMobilePriceIndicator/PublicationMobilePriceIndicator';

// Componentes existentes reutilizados
import CarBrandCharacteristics from '../CarBrandCharacteristics/CarBrandCharacteristics';
import ModalCharacteristics from '../PublicationDetail/components/ModalCharacteristics/ModalCharacteristics';
import Slider from '../SliderTwo';
import Button from '../Button';
import { Markup } from 'interweave';
import { images } from '../../constants/images';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';

import styles from './publicationDetailMobile.module.scss';
import PublicationStatusBadge from './components/PublicationStatusBadge/PublicationStatusBadge';
import { useNavigate } from 'react-router-dom';

type PublicationDetailMobileProps = Pick<PublicationDetailProps,
    'type' | 'publication' | 'loading' | 'children' | 'logoDealerships' |
    'onLinzeCheckClick' | 'handleDealerLogoClick' | 'onAutoFinClick' |
    'vehicleTypeSelected' | 'brand' | 'brandsDealerships' | 'selectedDealership' |
    'setSelectedDealership' | 'setOpenAdditionalModal' | 'selectedVersion' |
    'setSelectedVersion' | 'user' | 'setLoginRedirection' | 'loginBancoChile'
> & {
    showNegotiationInProgress?: boolean;
};

const PublicationDetailMobileRefactored = ({
    type = "publication",
    publication,
    loading = false,
    children,
    handleDealerLogoClick,
    logoDealerships,
    onLinzeCheckClick,
    onAutoFinClick,
    vehicleTypeSelected,
    brand,
    brandsDealerships,
    selectedDealership,
    setSelectedDealership,
    selectedVersion,
    setSelectedVersion,
    user,
    setLoginRedirection,
    showNegotiationInProgress = false,
    loginBancoChile
}: PublicationDetailMobileProps) => {
    const navigate = useNavigate();

    // Hooks personalizados
    const hookData = usePublicationDetail({ publication });
    const {
        openAdditionalModal,
        setOpenAdditionalModal,
        handleMokService,
        handleMaviService,
        handleFullMecService,
        handleIcarTagService,
        handleHDIService
    } = usePublicationLogic({
        publication,
        brandsDealerships,
        selectedDealership,
        setSelectedDealership,
        selectedVersion,
        setSelectedVersion,
        setVehicleTypeReducer: undefined
    });

    const {
        addPointsInText,
        boldBetweenAsterisks,
        hasValidSuggestedPrices,
        hasValidSuggestedPricesPublication,
        getPriceCategory,
        getPriceCategoryPublication,
        getIndicatorPosition,
        getIndicatorPositionPublication,
        getPriceDifferenceMessage,
        isBonus,
        selectedFeatures,
    } = publication && !loading ? hookData : {
        addPointsInText: (text: string) => text,
        boldBetweenAsterisks: (text: string) => text,
        hasValidSuggestedPrices: false,
        hasValidSuggestedPricesPublication: false,
        getPriceCategory: () => "fair" as const,
        getPriceCategoryPublication: () => "fair" as const,
        getIndicatorPosition: () => 0,
        getIndicatorPositionPublication: () => 0,
        getPriceDifferenceMessage: () => "",
        isBonus: false,
        selectedFeatures: [],
    };

    const truncateText = (text: string, maxLength: number) => {
        if (!text) return '';
        return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
    };

    const renderImageSlider = () => {
        const getSliderOptions = () => {
            if (brand) {
                const selectedVehicle = publication?.vehicles?.find((v: any) => v._id === selectedVersion);
                const allImages = [];

                const mainPictures = publication?.pictures?.gallery || publication?.pictures || [];
                if (mainPictures && mainPictures.length > 0) {
                    const mainImages = mainPictures.map((item: any, index: number) => (
                        <img
                            loading="lazy"
                            key={`main-${index}`}
                            src={item?.path ?? item?.previewURL ?? item?.uri ?? item?.url}
                            className={publication?.paused && styles.paused}
                            alt={`${publication?.title} ${publication?.vehicle_data?.version ?? ""} año ${publication?.vehicle_data?.year || publication?.primary_description}`}
                            title={`${publication?.title} ${publication?.vehicle_data?.version ?? ""} año ${publication?.vehicle_data?.year || publication?.primary_description}`}
                        />
                    ));
                    allImages.push(...mainImages);
                }

                if (selectedVehicle?.images && selectedVehicle.images.length > 0) {
                    const vehicleImages = selectedVehicle.images.map((item: any, index: number) => (
                        <img
                            loading="lazy"
                            key={`vehicle-${index}`}
                            src={item?.path ?? item?.previewURL ?? item?.uri ?? item?.url}
                            className={publication?.paused && styles.paused}
                            alt={`${publication?.title} ${selectedVehicle.version || selectedVehicle.name || ''} año ${selectedVehicle.year || publication?.year}`}
                            title={`${publication?.title} ${selectedVehicle.version || selectedVehicle.name || ''} año ${selectedVehicle.year || publication?.year}`}
                        />
                    ));
                    allImages.push(...vehicleImages);
                }

                return allImages.length > 0 ? allImages : [1].map((_: any, index: number) => (
                    <img loading="lazy" key={index} src={images.noImagePublication} alt="No image found publication linzecar" title="No image found publication linzecar"/>
                ));
            }

            const picturesArray = publication?.pictures?.gallery || publication?.pictures || [];
            return picturesArray && picturesArray.length > 0
                ? picturesArray.map((item: any, index: number) => (
                    <img
                        loading="lazy"
                        key={index}
                        src={item?.path ?? item?.previewURL ?? item?.uri ?? item?.url}
                        className={publication?.paused && styles.paused}
                        alt={`${publication?.title} ${publication?.vehicle_data?.version ?? ""} año ${publication?.vehicle_data?.year || publication?.primary_description}`}
                        title={`${publication?.title} ${publication?.vehicle_data?.version ?? ""} año ${publication?.vehicle_data?.year || publication?.primary_description}`}
                    />
                ))
                : [1].map((_: any, index: number) => (
                    <img loading="lazy" key={index} src={images.noImagePublication} alt="No image found publication linzecar" title="No image found publication linzecar" />
                ));
        };

        return (
            <div className={styles.sliderContainer}>
                <PublicationStatusBadge
                    publication={publication}
                    type={type}
                />
                <Slider
                    className={styles.slider}
                    sliderClassName={styles.sliderPreview}
                    thumbsClassName={styles.sliderThumbs}
                    type="thumbs"
                    options={getSliderOptions()}
                    pagination
                    arrows={true}
                    perView={5}
                    spaceBetween={10}
                    loading={loading && (!Array.isArray(publication?.pictures?.gallery || publication?.pictures) && !(publication?.pictures?.gallery || publication?.pictures)?.length)}
                />
            </div>
        );
    };

    const renderVehicleDescription = () => {
        if (!publication?.chatgpt_description_summary && !publication?.chatgpt_description) return null;

        return (
            <div className={styles.vehicleDescription}>
                <div className={styles.descriptionHeader}>
                    <p className={styles.title}>Descripción del vehículo</p>
                    <p className={styles.subtitle}>
                        <AutoAwesomeIcon className={styles.svg} />
                        <span className={styles.textIA}>Generado por Linze IA</span>
                    </p>
                </div>
                <p className={styles.descriptionText}>
                    {publication?.chatgpt_description_summary || publication?.chatgpt_description}
                </p>
                <div
                    className={styles.additionalCharacteristicsLinkPubli}
                    onClick={() => setOpenAdditionalModal && setOpenAdditionalModal(true)}
                >
                    Ver características adicionales
                </div>
            </div>

        );
    };

    const renderSalePostFeatures = () => {
        if (type !== "salePost" || !selectedFeatures?.length) return null;

        return (
            <div className={styles.additionalFeatures}>
                <h3 className={styles.featuresTitle}>Características adicionales</h3>
                <div className={styles.featuresContainer}>
                    {selectedFeatures.map((feature: any, index: number) => (
                        <Chip
                            key={index}
                            label={feature.name || feature}
                            className={styles.featureChip}
                            size="small"
                        />
                    ))}
                </div>
            </div>
        );
    };

    const renderSalePostRecords = () => {
        if (type !== "salePost" || !publication?.records?.length) return null;

        return (
            <div className={styles.additionalDetails}>
                {publication.records.map((item: any, index: number) => (
                    <p key={index} className={styles.detailText}>
                        <img src={`${item?.icon}`} alt={item?.name} title={item?.name} /> {item.value}
                    </p>
                ))}
            </div>
        );
    };

    const renderPromoBanners = () => {
        if (type !== "salePost" && vehicleTypeSelected === "used") {
            return (
                <div className={styles.imageSection} onClick={onLinzeCheckClick}>
                    <img
                        src={images.autoIcar}
                        alt="autoIcar imagen"
                        title="autoIcar imagen"
                        className={styles.promoImage}
                    />
                    <div className={styles.overlay}>
                        <p className={styles.overlayTitle}>icar</p>
                        <p className={styles.overlayText}>Adquiere el informe técnico del vehículo</p>
                        <Button
                            title="Solicitar Informe"
                            onPress={onLinzeCheckClick}
                            tertiary
                            size='small'
                            className={`${styles.btnInformeOverlay} ${styles.customButtonOverlay}`}
                        />
                    </div>
                </div>
            );
        }

        if (type === "myPublication" && vehicleTypeSelected === "new") {
            return (
                <div className={styles.imageSectionAutoFin} onClick={onAutoFinClick}>
                    <img
                        src={images.llaveAutoFin}
                        alt="llaveAutoFin imagen"
                        title="llaveAutoFin imagen"
                        className={styles.promoImage}
                    />
                    <p className={styles.overlayAutoFin}>
                        <img
                            src={images.logoAutoFin}
                            alt="logoAutoFin imagen"
                            title="logoAutoFin imagen"
                            className={styles.promoLogo}
                        />
                        <p className={styles.overlayTextAutoFin}>Calcula tus cuotas y financia tu nuevo auto</p>
                        <Button
                            title="Calcular mi crédito"
                            onPress={onAutoFinClick}
                            tertiary
                            size='small'
                            className={`${styles.btnAutoFinOverlay} ${styles.customButtonAutoFinOverlay}`}
                        />
                    </p>
                </div>
            );
        }

        if (type === "salePost") {
            return (
                <div
                    className={`${styles.imageSection} ${styles.disabled}`}
                    onClick={(e) => e.preventDefault()}
                >
                    <img
                        src={images.autoIcar}
                        alt="autoIcar imagen"
                        title="autoIcar imagen"
                        className={styles.promoImage}
                    />
                    <div className={styles.overlay}>
                        <p className={styles.overlayTitle}>icar</p>
                        <p className={styles.overlayText}>Adquiere el informe técnico del vehículo</p>
                        <Button
                            title="Solicitar Informe"
                            onPress={onLinzeCheckClick}
                            tertiary
                            size='small'
                            disabled
                            className={`${styles.btnInformeOverlay} ${styles.customButtonOverlay}`}
                        />
                    </div>
                </div>
            );
        }

        return null;
    };

    const renderSalePostButtons = () => {
        if (type !== "salePost") return null;

        return (
            <div className={styles.buttonRow}>
                <div className={styles.priceIndicatorWrapper}>
                    {hasValidSuggestedPrices && (getPriceCategory() === "good" || getPriceCategory() === "fair") && (
                        <div className={styles.priceIndicator}>
                            <img
                                src={
                                    getPriceCategory() === "good"
                                        ? images.checkVerde
                                        : images.checkAmarillo
                                }
                                alt="Indicador de precio"
                                title="Indicador de precio"
                                className={styles.priceIcon}
                            />
                            {getPriceCategory() === "good"
                                ? "Buen precio"
                                : "Precio justo"}
                        </div>
                    )}
                </div>
                <div className={styles.buttons}>
                    <Button
                        title="Negociar"
                        onPress={() => console.log('Negociar')}
                        tertiary
                        disabled
                        size='small'
                        className={styles.button}
                    />
                    <Button
                        title="Comprar"
                        onPress={() => console.log('Comprar')}
                        primary
                        disabled
                        size='small'
                        className={styles.button}
                    />
                </div>
            </div>
        );
    };

    return (
        <div className={styles.container}>
            {renderImageSlider()}

            {showNegotiationInProgress && (
                <div className={styles.negotiationBanner}>
                    Ya iniciaste esta negociación
                </div>
            )}

            <PublicationMobileContent
                publication={publication}
                loading={loading}
                truncateText={truncateText}
                boldBetweenAsterisks={boldBetweenAsterisks}
                logoDealerships={logoDealerships}
                handleDealerLogoClick={handleDealerLogoClick}
                brand={brand}
                type={type}
                vehicleTypeSelected={vehicleTypeSelected}
                selectedVersion={selectedVersion}
                addPointsInText={addPointsInText}
                hasValidSuggestedPricesPublication={type === "salePost" ? hasValidSuggestedPrices : hasValidSuggestedPricesPublication}
                getPriceCategoryPublication={type === "salePost" ? getPriceCategory : getPriceCategoryPublication}
                getIndicatorPositionPublication={type === "salePost" ? getIndicatorPosition : getIndicatorPositionPublication}
                getPriceDifferenceMessage={getPriceDifferenceMessage}
                loginBancoChile={loginBancoChile}
            >
                {type === "myPublication" ? children : null}
            </PublicationMobileContent>

            <PublicationMobileVersionSelector
                publication={publication}
                selectedVersion={selectedVersion}
                setSelectedVersion={setSelectedVersion}
                type={type}
                vehicleTypeSelected={vehicleTypeSelected}
                brand={brand}
                addPointsInText={addPointsInText}
            />

            <PublicationMobileDealershipSelector
                type={type}
                vehicleTypeSelected={vehicleTypeSelected}
                brand={brand}
                brandsDealerships={brandsDealerships}
                selectedDealership={selectedDealership}
                setSelectedDealership={setSelectedDealership}
            />

            <PublicationMobileCharacteristics
                publication={publication}
                loading={loading}
                brand={brand}
                selectedVersion={selectedVersion}
                setOpenAdditionalModal={setOpenAdditionalModal}
            />

            <div className={styles.serviceBox}>
                <ServiceBoxs
                    onIcarClick={(formData) => {
                        if (onLinzeCheckClick) {
                            onLinzeCheckClick();
                        }
                    }}
                    onIcarTagClick={handleIcarTagService}
                    onMaviClick={handleMaviService}
                    onMokClick={handleMokService}
                    onFullMecClick={handleFullMecService}
                    onHDIClick={handleHDIService}
                    user={user}
                    setLoginRedirection={setLoginRedirection}
                    vehicleTypeSelected={vehicleTypeSelected}
                />
            </div>

            {renderVehicleDescription()}
            {renderSalePostFeatures()}
            {renderSalePostRecords()}

            {publication?.status_brief?.code !== "sold_out" && ((type === "salePost" ? getPriceCategory() : getPriceCategoryPublication()) === "good" || (type === "salePost" ? getPriceCategory() : getPriceCategoryPublication()) === "fair") && (
                <PublicationMobilePriceIndicator
                    hasValidSuggestedPricesPublication={type === "salePost" ? hasValidSuggestedPrices : hasValidSuggestedPricesPublication}
                    getPriceCategoryPublication={type === "salePost" ? getPriceCategory : getPriceCategoryPublication}
                    getIndicatorPositionPublication={type === "salePost" ? getIndicatorPosition : getIndicatorPositionPublication}
                    getPriceDifferenceMessage={getPriceDifferenceMessage}
                    publication={publication}
                    brand={brand}
                    truncateText={truncateText}
                />
            )}

            <div className={styles.pagoSeguro}>
                <div className={styles.pagoSeguroLeft}>
                    <img src={images.pagoSeguro} alt="Secure Payment" width={18} height={14} />
                    <span className={styles.pagoSeguroText}>Pago seguro garantizado</span>
                </div>
                <img src={images.pagaEnLinea} alt="Paga en Línea" height={20} />
            </div>

            <PublicationMobileActions
                publication={publication}
                loading={loading}
                isBonus={isBonus}
            />

            <ModalCharacteristics
                open={openAdditionalModal}
                onClose={() => setOpenAdditionalModal(false)}
                selectedVehicleId={selectedVersion || ''}
                publication={publication}
            />

            {type !== 'myPublication' && publication?.status_brief?.code !== "sold_out" && (
                <div className={`${styles.stickyButtonContainer} ${styles.visible}`}>
                    <div className={styles.stickyPriceTop}>
                        <span className={styles.stickyPriceAmount}>$ {addPointsInText(publication?.price)}</span>
                        <div className={styles.stickyCreditLink} onClick={() => navigate('/financiar-auto')}>
                            <img src={images.iconCalculator} alt="Calcula tu crédito" />
                            <span>Calcula tu crédito</span>
                        </div>
                    </div>

                    <div className={styles.stickyButtonsSection}>
                        <div className={styles.stickyChildrenWrapper}>
                            {children}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default memo(PublicationDetailMobileRefactored);
